import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestaurantTableService } from '../../../services/restaurantTable.service';
import { RestaurantTable, RestaurantTableStatus } from '../../../models/restaurantTable.model';
import { UpdateRestaurantTableStatusDto } from '../../../models/dtos/updateRestaurantTableStatus.dto';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    PaginatorModule,
    DropdownModule,
    TooltipModule,
    TagModule,
  ],
  selector: 'app-list-restaurant-table',
  templateUrl: './list-restaurant-table.component.html',
  styleUrls: ['./list-restaurant-table.component.css'],
})
export class ListRestaurantTableComponent implements OnInit {
  tables: RestaurantTable[] = [];
  loading = true;
  totalRecords = 0;
  first = 0;
  rows = 5;
  currentPage = 1;
  statusFilter: string = '';
  statusOptions = [
    { label: 'Todos', value: '' },
    { label: 'Disponível', value: 'DISPONIVEL' },
    { label: 'Ocupada', value: 'OCUPADA' },
    { label: 'Reservada', value: 'RESERVADA' },
  ];

  constructor(
    private restaurantTableService: RestaurantTableService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.loadTables();
  }

  loadTables(): void {
    this.loading = true;
    const status = this.statusFilter ? (this.statusFilter as RestaurantTableStatus) : undefined;
    this.restaurantTableService.list(status, this.currentPage).subscribe({
      next: (response) => {
        this.tables = Array.isArray(response.data) ? response.data : [];
        this.totalRecords = response.pagination?.totalRecords ?? 0;
        this.first = (this.currentPage - 1) * this.rows;
        this.loading = false;
      },
      error: () => {
        this.tables = [];
        this.totalRecords = 0;
        this.loading = false;
      },
    });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.first = 0;
    this.loadTables();
  }

  createTable(): void {
    this.router.navigate(['/app/restaurant/tables/new']);
  }

  edit(table: RestaurantTable): void {
    this.router.navigate(['/app/restaurant/tables/edit', table.id]);
  }

  changeStatus(table: RestaurantTable, newStatus: RestaurantTableStatus): void {
    const dto: UpdateRestaurantTableStatusDto = { status: newStatus };
    this.restaurantTableService.updateStatus(table.id, dto).subscribe({
      next: () => this.loadTables(),
      error: () => alert('Erro ao alterar status da mesa.'),
    });
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.rows = event.rows ?? this.rows;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.loadTables();
  }

  getStatusSeverity(status: string): string {
    switch (status) {
      case 'DISPONIVEL': return 'success';
      case 'OCUPADA': return 'warn';
      case 'RESERVADA': return 'info';
      default: return 'secondary';
    }
  }

  getStatusLabel(status: string): string {
    const opt = this.statusOptions.find(o => o.value === status);
    return opt?.label ?? status;
  }
}
